<mat-progress-spinner [value]="remaining * 100 / timeoutDelay" color="accent" [diameter]="30"></mat-progress-spinner>
<span matSnackBarLabel>{{ 'LABEL.SESSION_EXPIRATION_SNACKBAR' | translate: {value: remaining} }}</span>
